import { Injectable } from '@angular/core';

import { PaginatedResults, PaginationInfo } from '@stylehaven/components';
import { ApiFragment, ApiFragmentList } from '../entities/api-fragment.entity';
import { Metadata } from '../entities/metadata.entity';

@Injectable()
export class FragmentService {
    public parsePaginatedApiResponse(
        apiResponse: ApiFragmentList,
        resultsPerPage: number | undefined
    ): PaginatedResults<ApiFragment> {
        const paginationInfo: PaginationInfo = {
            totalNumberOfResults: apiResponse.TotalNrOfResults,
            page: apiResponse.StartIndex / Number(resultsPerPage),
            resultsPerPage: Number(resultsPerPage)
        };

        const fragments: ApiFragment[] = this.mapToRecordList(apiResponse.Results);

        const paginatedResults: PaginatedResults<ApiFragment> = {
            paginationInfo,
            results: fragments
        };

        return paginatedResults;
    }

    private mapToRecordList(metadataList: Metadata[]): ApiFragment[] {
        return metadataList.map(result => this.mapToFragment(result));
    }

    private mapToFragment(fragmentJSON: Metadata): ApiFragment {
        return new ApiFragment(fragmentJSON);
    }
}
